import React, { useState } from 'react'
import styled from './index.module.css'
import Banner from '../../img/insurance_banner.png'

const InsurancePage = (props:any) => {

    const [selectTab, setselectTab] = React.useState(0)
    const selectTabButton = (tabIndex:any) => { setselectTab(tabIndex)}
    
    // 보험 정보 템플릿
    const Template = () => {
        return (
            <div className={styled.insurance_info}>
                <div className={styled.title}>펫퍼민트 Puppy & Family 다이렉트</div>
                <div className={styled.describe}>반려동물 실손의료비 보험(인터넷 가입) {/** Icon */} </div>
                <div className={styled.banner}>
                    <img src={Banner} alt='banner'/>
                </div>

                <div className={styled.detail_title}>상세정보</div>
                <div className={styled.details}>
                    <p>
                    1.슬개골/피부 관련 질환 보장 소형견 발병 비율이 높은 관절 관련 질환 및 피부, 구강 질환을 보장해 드려요. <br/>
                    (특약, 치과치료 미보장, 슬개골 및 고관절은 1년 이내 발생 시 미보장) <br/><br/>
                    2.5년 자동갱신으로 만 20세까지 보장 보험 가입 후엔 반려동물이 아파도, 나이가 들어도 만 20세까지 치료비 걱정을 줄여드려요. <br/>
                    (5년 만기 선택 시, 갱신 시 보험료 인상 가능) <br/>
                    </p>
                </div>
            </div>
        )
    }
    
    const insurList = [<Template/>, <Template/>, <Template/>]

    const InsuranceInfo = () => {
        return (
            <div className={styled.insurance_list}>
                <div className={styled.tab}>
                    <ul>
                        <li className={`${selectTab === 0 ? styled.on : ''}`}>
                            <div onClick={()=>selectTabButton(0)}>삼성화재</div>
                        </li>
                        <li className={`${selectTab === 1 ? styled.on : ''}`}>
                            <div onClick={()=>selectTabButton(1)}>동부화재</div>
                        </li>
                        <li className={`${selectTab === 2 ? styled.on : ''}`}>
                            <div onClick={()=>selectTabButton(2)}>메리츠화재</div>
                        </li>
                    </ul>
                </div>

                {/** 보험 정보 리스트 */}
                {insurList[selectTab]}
        </div>
        )
    }

    

    const CustomerList = () => {
        const [customers, setCustomers] = useState([1, 2, 3, 4, 5])

        return (
            <div style={{width:'100%', height:'100%', marginLeft:'50px'}}>
                <div className={styled.customer_title}> 안쿠마동물병원을 통한 가입고객 리스트 </div>
                <div className={styled.customer_list}>
                    { customers.map((customer, index) => { return <CustomerInformation/> }) }
                </div>
            </div>
        )
    }
    
    const CustomerInformation = () => {
        return (
            <div className={styled.customer_info}>
                <div className={styled.name}><span className={styled.tit}>반려동물</span>쿠마</div>
                <div className={styled.gender}><span className={styled.tit}>성별</span>여</div>
                <div className={styled.age}><span className={styled.tit}>나이</span>1살</div>
                <div className={styled.weight}><span className={styled.tit}>무게</span>12kg</div>
                <div className={styled.guardian}><span className={styled.tit}>보호자</span>김민수</div>
                <div className={styled.phone}><span className={styled.tit}>전화번호</span>010-1234-5678</div>
            </div> 
        )
    }
    return (
        <div className="contents" style={{opacity:'0.3', pointerEvents:'none'}}>
        {/** 이부분만 지우면됨 */}
        <div style={{display:'flex', position:'absolute', zIndex:'30', 
            left:'50%', top:'50%', fontWeight:'bolder', fontSize:'32px'}}>준비중입니다</div>
            <InsuranceInfo/>
            <CustomerList/>
        </div>
    )

}

export default InsurancePage
